module.exports = __webpack_public_path__ + "img/defaultNep17.53212e64.png";